import {SVGProps} from 'react';

const AmexLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        fill="none"
        height="24"
        viewBox="0 0 35 24"
        width="35"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            fill="#1F72CD"
            height="23"
            rx="5.5"
            stroke="#D9D9D9"
            width="34"
            x="0.5"
            y="0.5"
        />
        <path
            clipRule="evenodd"
            d="M6.27467 8.5L3 15.7467H6.92024L7.40624 14.5913H8.51712L9.00311 15.7467H13.3182V14.8649L13.7027 15.7467H15.9348L16.3193 14.8462V15.7467H25.2935L26.3847 14.6213L27.4065 15.7467L32.0158 15.7561L28.7308 12.1436L32.0158 8.5H27.478L26.4158 9.60463L25.4261 8.5H15.6634L14.8251 10.3704L13.9671 8.5H10.055V9.35186L9.61981 8.5H6.27467ZM19.6758 9.52905H24.8292L26.4054 11.2316L28.0324 9.52905H29.6086L27.2137 12.1426L29.6086 14.726H27.9609L26.3847 13.0036L24.7494 14.726H19.6758V9.52905ZM20.9484 11.555V10.6057V10.6048H24.164L25.5671 12.1229L24.1018 13.6493H20.9484V12.613H23.7598V11.555H20.9484ZM7.03322 9.52905H8.94413L11.1162 14.4431V9.52905H13.2095L14.8872 13.0524L16.4334 9.52905H18.5163V14.7291H17.2489L17.2386 10.6544L15.3908 14.7291H14.2571L12.3991 10.6544V14.7291H9.79178L9.29749 13.5633H6.62701L6.13374 14.728H4.73679L7.03322 9.52905ZM7.08299 12.4856L7.96281 10.4089L8.8416 12.4856H7.08299Z"
            fill="white"
            fillRule="evenodd"
        />
    </svg>
);
export default AmexLogo;
